import { render, staticRenderFns } from "./KoioteDecimalSelect.vue?vue&type=template&id=69c1b9d0&lang=true"
import script from "./KoioteDecimalSelect.vue?vue&type=script&lang=js"
export * from "./KoioteDecimalSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports